import { Attribute } from "~/types/data/Attribute.types";
import { AttributeValue } from "~/types/data/AttributeValue.types";
import { Product } from "~/types/data/Product.types";

export const getAttributeValues = <K extends keyof Product>(
  attribute: Attribute | undefined
) => {
  return (attribute?.values as AttributeValue<Product[K]>[]) || [];
};
